import { render } from "./ChristmasOfferTitle.vue?vue&type=template&id=edcfa480&scoped=true"
import script from "./ChristmasOfferTitle.vue?vue&type=script&lang=js"
export * from "./ChristmasOfferTitle.vue?vue&type=script&lang=js"

import "./ChristmasOfferTitle.vue?vue&type=style&index=0&id=edcfa480&lang=scss&scoped=true"

import exportComponent from "/src/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-edcfa480"],['__file',"src/components/christmas-offer/ChristmasOfferTitle.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "edcfa480"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('edcfa480', __exports__)) {
    console.log('reload')
    api.reload('edcfa480', __exports__)
  }
  
  module.hot.accept("./ChristmasOfferTitle.vue?vue&type=template&id=edcfa480&scoped=true", () => {
    console.log('re-render')
    api.rerender('edcfa480', render)
  })

}


export default __exports__